import { CheckboxButton, colors, DropdownSingle } from "oolib";
import React from "react";
import styled from 'styled-components'



const SelectWrapperOverride = styled.div`
  width: 100%;
  
  .StyledDropdownRefWrapper_styleOverrideHandle {
    
  }

  /* Target the StyledSelectWrapper inside */
  .StyledSelectWrapper_styleOverrideHandle {
    
    &::before {
      background-color: unset;
      border: none;
      /* whatever ::before styles you want */
    }
  }
`;

const TableDropdownSingle = (props) => {
  const { id, value, onChange, options, saveValueAsString = true, disabled = false } = props;

  return (
    <SelectWrapperOverride
    onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
         }}
    >
    <DropdownSingle
      disabled={disabled}
      
      saveValueAsString={saveValueAsString}
      S
      value={value}
      options={options}
      popOutOfOverflowHiddenParent
      onChange={onChange}
    />
    </SelectWrapperOverride>
  );
};

export default TableDropdownSingle;
